var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.inIframe)?_c('div',{staticClass:"breadcrumb-box"},[_c('Breadcrumb',_vm._l((_vm.breadcrumbList),function(item,index){return _c('BreadcrumbItem',{key:index,attrs:{"to":item.to}},[_vm._v(" "+_vm._s(item.text)+" ")])}),1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }